export default __webpack_public_path__ + "static/media/IAP_konfety.587eaba6.jpg";